export default "/images/c411db8658c64d663849f00ed3065628.avif";